
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqA5_45M064JLA9U_45D6F9cFcwTHjOgQlc00Fg4AsYrqAM_sMeta } from "/codebuild/output/src2403144023/src/src/pages/faq.vue?macro=true";
import { default as menu0Muy2DQYq6jBj7AIO_j7N1ovBTBT3riBBr_45Fw0CoUtQMeta } from "/codebuild/output/src2403144023/src/src/pages/menu.vue?macro=true";
import { default as indexdgx1h_0nhl74VC3EVA3wSy1jMuDQ2DKrstTKjhDQixQMeta } from "/codebuild/output/src2403144023/src/src/pages/index.vue?macro=true";
import { default as contact1XcJmCPlGlu1n64tBWfcVYo3dYusyxBthVsJvwUzqU8Meta } from "/codebuild/output/src2403144023/src/src/pages/contact.vue?macro=true";
import { default as tutorialmXPyVcqj7g0jFM6BhYAqsANpAJZkYSmF5qGrhgHfPXAMeta } from "/codebuild/output/src2403144023/src/src/pages/tutorial.vue?macro=true";
import { default as agreementKShKCoBQnGDRISgPZdopNni8Egtfzl1_45vd1lW6Y6rNgMeta } from "/codebuild/output/src2403144023/src/src/pages/agreement.vue?macro=true";
import { default as about_45passj8ImHMj7fk7yIeQrkIliOE0Zda56Sylw_45R4LVwJgexUMeta } from "/codebuild/output/src2403144023/src/src/pages/about-pass.vue?macro=true";
import { default as index8YzKW5Kii4oW6d1ko1ZXzi6ywSsOTyNnEhpU8uLAhyAMeta } from "/codebuild/output/src2403144023/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93bArNbEKQqnCsrdlADd7Ox1pi4qRh4RyPcJKN2Rsxt2cMeta } from "/codebuild/output/src2403144023/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancej7ixZ2At0zz0WUouNwL3n6Nk6uOrV_452SYmMFT4LYLXgMeta } from "/codebuild/output/src2403144023/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93cs1BVxZ_L1BHf8D6a4227I97PijwhHRe99DfoYw6N4gMeta } from "/codebuild/output/src2403144023/src/src/pages/notice/[id].vue?macro=true";
import { default as indexa_45Iwg_45_gJ9u8nUpy65JVKSLjlQkq7npAX_RAEorE08oMeta } from "/codebuild/output/src2403144023/src/src/pages/coupon/index.vue?macro=true";
import { default as indexOlPWYQNSMVofx9xTSRzUX_45IKIcZWAmKUx7OY3itwSwkMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/index.vue?macro=true";
import { default as index3pnaRqVfk3nKnNMpBlFNSX5GAJ2A2VuDHez5ieKmoj0Meta } from "/codebuild/output/src2403144023/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93ddgpa9zeylziw4CzrKgMUXa0h0K7U4HvpuQr7bhGjvIMeta } from "/codebuild/output/src2403144023/src/src/pages/parking/[id].vue?macro=true";
import { default as indexnpaUaQx5aYOQvuEWrNpoy3qIdAWJh_45B6DLnAB6YFs7gMeta } from "/codebuild/output/src2403144023/src/src/pages/history/index.vue?macro=true";
import { default as indexge8kDOM3yTKinC1HGoI1jpFgkpAe_dStVdA_45nx19JEYMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/index.vue?macro=true";
import { default as indexr4eeDNCKRKoIUPmc8HSN5qmLklZwGfqAI0thRlUqx6IMeta } from "/codebuild/output/src2403144023/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexjIQR5asPyf1_45siPNgOJQ_li48sy0pkwBigEBr7KcJEUMeta } from "/codebuild/output/src2403144023/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviJCkJjdm5PoGV_CmSLIDpDENV9OFIG3xRFwSimGQvavkMeta } from "/codebuild/output/src2403144023/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit4kfGuIJt19KDNquP7aVuzaJjjh5zCtKy5WpQp30G5b8Meta } from "/codebuild/output/src2403144023/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement0utWU62RwfyrY9JjgERxqEQHzGfvKFbrAx6xeaEh70QMeta } from "/codebuild/output/src2403144023/src/src/pages/pass-agreement.vue?macro=true";
import { default as indextCsWwgAoaRqn21OdrxAwNi085XcW5PcP5L8oW_kJ4wwMeta } from "/codebuild/output/src2403144023/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453ddwsvxuQp1DvVA_rbBWMr45fRMA_rCl9JrfaKqWR5_451cMeta } from "/codebuild/output/src2403144023/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmk_45PVhzKFiXwcObBpWMEWybaUeGEx3r4BDCAwZUo2QrYMeta } from "/codebuild/output/src2403144023/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexImW_45mvJpu5DA42oLqITrM_45WGJ9ZCQyff3ztpB6RWFjQMeta } from "/codebuild/output/src2403144023/src/src/pages/card/create/index.vue?macro=true";
import { default as indexOLKLg0Jc7dQyn_mOAZj8Z2AdYGbFTCUyzGDexEsCjH8Meta } from "/codebuild/output/src2403144023/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmKkrf8aQ29FfgPuX2_4560WNfnIL_RL6P7OXpT2Po03Y5UMeta } from "/codebuild/output/src2403144023/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmVJPxf7S9SLWQUvounSB8IwoSQy48BcRipHp42bTr7kcMeta } from "/codebuild/output/src2403144023/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeJ_v3kJE814HwmXQDybc6xBMR4G_45R3U6JZj1OKHCPu4oMeta } from "/codebuild/output/src2403144023/src/src/pages/membership/complete.vue?macro=true";
import { default as registerCABHqesEvJsDxLZMK5B_pRlmNRAGMWJandkYHS_q3esMeta } from "/codebuild/output/src2403144023/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93_45_8fLl0UGOXdNRNxnPKF7D8dD1fEVPf1_JneXXL4AdMMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmHKkIfq71bhUKM12H0aIeRasc7LmocQAXJh_459dtl75e4Meta } from "/codebuild/output/src2403144023/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93kW3Yb5T_jjOGiu7wFVszrfyYqZEPAZeLC9kS6jX1tm0Meta } from "/codebuild/output/src2403144023/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexqHONrL2T1DutxJLNMKJfchuwezSzI5Q0MGTOafsNQ5gMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code8TDOoN_45iZIUJmBNeRk2jf5cruxknegC3UyB2b0WNXSQMeta } from "/codebuild/output/src2403144023/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeGg5ckOyJDWVXAMBczrY5vbdwrq_a_Uo8YlJaGsihDHoMeta } from "/codebuild/output/src2403144023/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completejWqtefLm5__8N09leh1beGRPB9MuPevfQg12IhY4h8oMeta } from "/codebuild/output/src2403144023/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerIjlZR5lPzsFCT5i7i4XtDPE0pffXQ1AbaHCzHfAncV0Meta } from "/codebuild/output/src2403144023/src/src/pages/contact-form/register.vue?macro=true";
import { default as completebt11FhcgjaI1KIv0Q5weKj3nl4o8JdA6qnHSDhoG2BMMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexdLitHvypM4VWWqrVwyizs7TN8Dk0TXSRtwPFiZ6IOK8Meta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmEH0_45KYeQWHoeRaSXnfaUS0yOmzs7O5DBppUGUESGOgAMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeSO59jpbCvcNbcMNhh7pjcw4w3jEzoqhPbPmhrU4nz_45IMeta } from "/codebuild/output/src2403144023/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexNqAwyuKXVwbO7Ba7V6fcKixIMskLqb6D1thx78Fc3qMMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_935tgO2VorhXCH40vj89zajzB3O9E5SmhFh7E5oeouNwMMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeZgYD_JyLtKEu6lH3b6fU6sUNertG2RGrPoH1qk4uQKMMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias0Qip5azxceHpgXybN3YUdYFB7siu_45JyI_3IoxTT9UrgMeta } from "/codebuild/output/src2403144023/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplePHacqxJYBWt1X_1o0c44R6BnY0vVfb9u8JeyS__45yu0sMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email0IXn6CZfJzDXQ9KX8E_45voK0gj3JMlOut25LpW_r9NbgMeta } from "/codebuild/output/src2403144023/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmPYzprcTdUaJDmlTyk0bDEHfT3LDq05tctuo5M9KDo54Meta } from "/codebuild/output/src2403144023/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentIFxqDdFjAFpFzFP3Lazlc_x5iMULvIPHaJdcKGtaxTEMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmiIMMaW5gngLYXtLxY9_7fynXJqMz4ltRU0t9DT_2FSwMeta } from "/codebuild/output/src2403144023/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateOCHo4R3Ck_yhUAdznR4cJv936j6sdtH3h1Bw_WgPzcYMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete4UUvaQOwVX_45JaksVNsoj39Jb7CcVkrIIo4JYAxdq5rIMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeY_1WsCKFu4u1XVyrYnF3AgVwI7g3pspDQL8klMRuREQMeta } from "/codebuild/output/src2403144023/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordsqKki6k1fw3UI_45rv1CvMq8NcMquN4FQywH8_45X0TXXj4Meta } from "/codebuild/output/src2403144023/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias8HItTHTmMHMJTZ_45dGJ3J4GfmbhjEsNxLrSfICneUoYcMeta } from "/codebuild/output/src2403144023/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registereft7LJ3VVR7ptLc7YE2QSIS3N3xwsh_45K69oomVfq7wwMeta } from "/codebuild/output/src2403144023/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codegs2Px1D4hCxAzpTRP4f_FdZ6zYG_45nx_nGIJDcLuICGQMeta } from "/codebuild/output/src2403144023/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexWy00Di0QftfDl2YXZcV45aS7qRZsp949ukRVnmLCDnQMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexppOXOFslG7goeNZSL7yywELBblh0itspL_45O5ffs7ddcMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexWFMI8IEehV4yRirSUTkh6Kxgvr2nYjWEaA9dkdBAl9wMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indextCc4uBMk7_454Bj0WdBcL0GPeY3Uke6kl5LNU5pOEWNmcMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatekMnK08C4rIjpJuSgaX96jccrTmYHz9INClJR3fo6Lu0Meta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeOOh_J4mhOFe8Mem2xPIG__VducntqEZi6NuwEsa_p3EMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmNN3gFuI8E4X4GMmaNfQD2OPOlG_sk5156aPHJKiCpQoMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexpW24dzo2kcLFFgRxj5AcTIF3WwmsORQC7_4576EIDF8HYMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completefRM6NA79Ns8LnzppLH3GIakOfjj_I3NodtPjFVvvJ5sMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateFTtgtkWry0CH9iZrxv3k4FRYwk4i5AGsv_l1dEwM6fIMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexvw9VQ3gev3Rrm4jd7BrAKJ_45fyUZ0bLS2OnZjE70TDZwMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexH1gy5fK390R7TFdzokQ_45Ynh5sS4rXrbBMrgrVTSFl5oMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completegtdIbEcV_ykVOxQKKu8oNdWT1xU41MkgFxGq_453aTASsMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexOVjnyMy5C4OPUVIV9Czf8uPvkuRJyzBr08pcChTrZnkMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code6indNcsQJmRsdSAnNTUVupMn624lqlp0uz1aV1dU2qAMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexkh47n_45rq8zhBLUw7wUy87IQG8qInRZ_45ZVZhytpfhH3kMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexWSS5BmBxxE5Ft3cNSP74EF9Vc_45pwhwKDQQTEICFxNd0Meta } from "/codebuild/output/src2403144023/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index7wJbEx_45jE6oZDxKaBxtfnnB3JF8ARId3WAAoQ2aoSxYMeta } from "/codebuild/output/src2403144023/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateJ8kdjnT9gJhd8EipuYevM8e63ZBsnpDGMCU_JmMjtZYMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmw_459_baO4eBLlQppZFX3NBMqbJn4ayVOwsfBmUoLxK4sMeta } from "/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu0Muy2DQYq6jBj7AIO_j7N1ovBTBT3riBBr_45Fw0CoUtQMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexdgx1h_0nhl74VC3EVA3wSy1jMuDQ2DKrstTKjhDQixQMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexa_45Iwg_45_gJ9u8nUpy65JVKSLjlQkq7npAX_RAEorE08oMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2403144023/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexnpaUaQx5aYOQvuEWrNpoy3qIdAWJh_45B6DLnAB6YFs7gMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2403144023/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexr4eeDNCKRKoIUPmc8HSN5qmLklZwGfqAI0thRlUqx6IMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexjIQR5asPyf1_45siPNgOJQ_li48sy0pkwBigEBr7KcJEUMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexImW_45mvJpu5DA42oLqITrM_45WGJ9ZCQyff3ztpB6RWFjQMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmKkrf8aQ29FfgPuX2_4560WNfnIL_RL6P7OXpT2Po03Y5UMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmVJPxf7S9SLWQUvounSB8IwoSQy48BcRipHp42bTr7kcMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2403144023/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeJ_v3kJE814HwmXQDybc6xBMR4G_45R3U6JZj1OKHCPu4oMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerCABHqesEvJsDxLZMK5B_pRlmNRAGMWJandkYHS_q3esMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmHKkIfq71bhUKM12H0aIeRasc7LmocQAXJh_459dtl75e4Meta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code8TDOoN_45iZIUJmBNeRk2jf5cruxknegC3UyB2b0WNXSQMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeGg5ckOyJDWVXAMBczrY5vbdwrq_a_Uo8YlJaGsihDHoMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completejWqtefLm5__8N09leh1beGRPB9MuPevfQg12IhY4h8oMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerIjlZR5lPzsFCT5i7i4XtDPE0pffXQ1AbaHCzHfAncV0Meta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmEH0_45KYeQWHoeRaSXnfaUS0yOmzs7O5DBppUGUESGOgAMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeSO59jpbCvcNbcMNhh7pjcw4w3jEzoqhPbPmhrU4nz_45IMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexNqAwyuKXVwbO7Ba7V6fcKixIMskLqb6D1thx78Fc3qMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeZgYD_JyLtKEu6lH3b6fU6sUNertG2RGrPoH1qk4uQKMMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplePHacqxJYBWt1X_1o0c44R6BnY0vVfb9u8JeyS__45yu0sMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email0IXn6CZfJzDXQ9KX8E_45voK0gj3JMlOut25LpW_r9NbgMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmPYzprcTdUaJDmlTyk0bDEHfT3LDq05tctuo5M9KDo54Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentIFxqDdFjAFpFzFP3Lazlc_x5iMULvIPHaJdcKGtaxTEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmiIMMaW5gngLYXtLxY9_7fynXJqMz4ltRU0t9DT_2FSwMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete4UUvaQOwVX_45JaksVNsoj39Jb7CcVkrIIo4JYAxdq5rIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeY_1WsCKFu4u1XVyrYnF3AgVwI7g3pspDQL8klMRuREQMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordsqKki6k1fw3UI_45rv1CvMq8NcMquN4FQywH8_45X0TXXj4Meta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registereft7LJ3VVR7ptLc7YE2QSIS3N3xwsh_45K69oomVfq7wwMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codegs2Px1D4hCxAzpTRP4f_FdZ6zYG_45nx_nGIJDcLuICGQMeta || {},
    component: () => import("/codebuild/output/src2403144023/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2403144023/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]